import AddCustomField from "./AddCustomField"
import { AddCustomFieldProps } from "./AddCustomField"
export default AddCustomField
export type { AddCustomFieldProps }
